var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruckBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5714 5.86377H14.8571V12.9318H0V16.4659H1.14286C1.14286 18.4685 2.62857 19.9999 4.57143 19.9999C6.51429 19.9999 8 18.4685 8 16.4659H14.8571C14.8571 18.4685 16.3429 19.9999 18.2857 19.9999C20.2286 19.9999 21.7143 18.4685 21.7143 16.4659H24V10.5758L20.5714 5.86377ZM4.57143 18.2329C3.65714 18.2329 2.85714 17.4083 2.85714 16.4659C2.85714 15.5235 3.65714 14.6989 4.57143 14.6989C5.48571 14.6989 6.28571 15.5235 6.28571 16.4659C6.28571 17.4083 5.48571 18.2329 4.57143 18.2329ZM18.2857 18.2329C17.3714 18.2329 16.5714 17.4083 16.5714 16.4659C16.5714 15.5235 17.3714 14.6989 18.2857 14.6989C19.2 14.6989 20 15.5235 20 16.4659C20 17.4083 19.2 18.2329 18.2857 18.2329ZM17.1429 10.5758V7.63079H20L22.2857 10.5758H17.1429Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6443 9.19232C14.6443 11.0945 14.9759 12.6963 13.086 12.6963H10.5993C8.70941 12.6963 8.80886 11.0945 8.80886 9.19232C8.80886 7.29013 8.60994 6.35572 10.102 5.68829L9.60462 5.5256V5H13.5834V5.5256L13.086 5.68829C14.5781 6.35572 14.6443 7.15664 14.6443 9.19232Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.533325 7C0.533325 5.89543 1.42876 5 2.53333 5H6.53333C7.63789 5 8.53333 5.89543 8.53333 7V10.6963C8.53333 11.8009 7.63789 12.6963 6.53333 12.6963H2.53333C1.42876 12.6963 0.533325 11.8009 0.533325 10.6963V7Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 17.5444C10.4 16.9921 10.8477 16.5444 11.4 16.5444H12.0667C12.619 16.5444 13.0667 16.9921 13.0667 17.5444V17.7434C13.0667 18.2957 12.619 18.7434 12.0667 18.7434H11.4C10.8477 18.7434 10.4 18.2957 10.4 17.7434V17.5444Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckBlack);
export default __webpack_public_path__ + "static/media/truck-black.44f7382b721ff6f22375173e49085e5a.svg";
export { ForwardRef as ReactComponent };